import {
  Card,
  CardContent,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Box,
  Snackbar,
  Alert
} from '@mui/material';

import { format } from 'date-fns';
import { useState } from 'react';
import ContentCopy from '@mui/icons-material/ContentCopy';
import { Headset } from 'src/models/user';
import { modalStyles } from 'src/pages/dashboard/UsersDetailsLookup';
import UserHeadsetUsageDetails from './UserHeadsetUsageDetails';

interface Props {
  headsets: Headset[];
}

const UserHeadsetUsage = ({ headsets }: Props) => {
  const [selected, setSelected] = useState<Headset | undefined>();
  const [headsetModalOpen, setHeadsetModalOpen] = useState(false);
  const [toastOpen, setToastOpen] = useState(false);

  const headsetModalStyles = {
    ...modalStyles,
    overflow: 'hidden'
  };

  headsets.sort((a, b) => {
    if (!a.firstSessionDate || !b.firstSessionDate) {
      return 0;
    }
    const aFirst = new Date(a.firstSessionDate!.formatted);
    const bFirst = new Date(b.firstSessionDate!.formatted);
    return bFirst.getTime() - aFirst.getTime();
  });

  const handleCopyMac = (mac: string, event: React.MouseEvent) => {
    event.stopPropagation();
    navigator.clipboard.writeText(mac);
    setToastOpen(true);
  };

  const handleCloseToast = () => {
    setToastOpen(false);
  };

  return (
    <>
      <>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="left">MAC</TableCell>
                <TableCell align="left">Model No</TableCell>
                <TableCell align="left">First Session</TableCell>
                <TableCell align="left">Last Session</TableCell>
                <TableCell align="left">Total Sessions</TableCell>
                <TableCell align="left">Total Assessments</TableCell>
                <TableCell align="left">Had Warranty Event</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {headsets.map((row) => (
                <TableRow
                  key={row.id}
                  onClick={() => {
                    setSelected(row);
                    setHeadsetModalOpen(true);
                  }}
                  sx={{ cursor: 'pointer' }}
                >
                  <TableCell align="left">
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      {row.mac}
                      <IconButton
                        size="small"
                        onClick={(e) => handleCopyMac(row.mac, e)}
                        sx={{ padding: 0.5 }}
                      >
                        <ContentCopy fontSize="small" />
                      </IconButton>
                    </Box>
                  </TableCell>
                  <TableCell align="left">{row.modelNumber}</TableCell>
                  <TableCell align="left">
                    {format(
                      new Date(row.firstSessionDate?.formatted),
                      'MMM dd, yyyy'
                    )}
                  </TableCell>
                  <TableCell align="left">
                    {format(
                      new Date(row.lastSessionDate?.formatted),
                      'MMM dd, yyyy'
                    )}
                  </TableCell>
                  <TableCell align="left">{row.totalSessions ?? 0}</TableCell>
                  <TableCell align="left">
                    {row.totalAssessments ?? 0}
                  </TableCell>
                  <TableCell align="left">
                    {(row.warrantyEvents ?? []).length > 0 ? 'Yes' : 'No'}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </>
      <>
        <Modal
          open={headsetModalOpen}
          onClose={() => setHeadsetModalOpen(false)}
          sx={headsetModalStyles}
        >
          <Card sx={{ maxHeight: '100%', overflow: 'auto' }}>
            <CardContent>
              <UserHeadsetUsageDetails headset={selected} />
            </CardContent>
          </Card>
        </Modal>
      </>
      <Snackbar
        open={toastOpen}
        autoHideDuration={2000}
        onClose={handleCloseToast}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleCloseToast}
          severity="success"
          sx={{ width: '100%' }}
        >
          Copied to clipboard!
        </Alert>
      </Snackbar>
    </>
  );
};

export default UserHeadsetUsage;
